/**
 * @generated SignedSource<<b94f601ccf8010a3920820c4d7507779>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientFormCardItem_clientForm$data = {
  readonly createdAt: string | null | undefined;
  readonly name: string;
  readonly slug: string;
  readonly submittedAt: string | null | undefined;
  readonly " $fragmentType": "ClientFormCardItem_clientForm";
};
export type ClientFormCardItem_clientForm$key = {
  readonly " $data"?: ClientFormCardItem_clientForm$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientFormCardItem_clientForm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClientFormCardItem_clientForm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submittedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "format",
          "value": "MMM D, YYYY"
        }
      ],
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": "createdAt(format:\"MMM D, YYYY\")"
    }
  ],
  "type": "ClientForm",
  "abstractKey": null
};

(node as any).hash = "2c92fed288f20bb3599bd22755102cd8";

export default node;
